import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SearchItem, SearchEngineLabel } from 'modules/shared/models/screening.models';

@Component({
  selector: 'artemis-screening-error-message',
  templateUrl: './screening-error-message.component.html',
  styleUrls: ['./screening-error-message.component.scss']
})
export class ScreeningErrorMessageComponent implements OnInit {

  public errorMessages: { name: string, errors: string }[] = [];
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public failedPosts: SearchItem[],
    private snackbarRef: MatSnackBarRef<ScreeningErrorMessageComponent>
  ) { }

  ngOnInit() {
    const failedPostGroups = [];

    this.failedPosts.map((search: SearchItem) => {
      if (!failedPostGroups[search.record]) {
        failedPostGroups[search.record] = [];
      }
      failedPostGroups[search.record].push(search);
    });

    Object.keys(failedPostGroups).forEach((recordMsg: string) => {
      this.errorMessages.push({
        name: failedPostGroups[recordMsg][0].name,
        errors: failedPostGroups[recordMsg].map((search: SearchItem) => SearchEngineLabel[search.engineType].toString()).join(', ')
      });
    });
  }

  close() {
    this.snackbarRef.dismiss();
  }

}
